<template>
  <div
    class="relative flex flex-col w-screen h-full bg-white safe-area justify-between"
    :class="{ 'can-scroll': canScroll }"
  >
    <div class="head" :style="headStyle">
      <div class="absolute left-0 p-3">
        <slot name="leftBtn" />
      </div>
      <div class="font-semibold text-xl md:text-2xl" :class="{ uppercase: headUppercase }">
        <slot name="title" />
        {{ headText }}
      </div>
      <div class="absolute right-0 p-3">
        <slot name="rightBtn" />
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    headUppercase: Boolean,
    headText: String,
    headStyle: String,
    canScroll: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.head {
  @apply relative flex justify-center items-center w-10/12 mx-auto my-5;
  height: 30px;
  z-index: 1;
  @screen md {
    @apply my-10;
    width: 87%;
  }
}

.can-scroll {
  overflow-y: auto;
}
</style>
